import { forwardRef, useImperativeHandle } from 'react';
import { useThree } from '@react-three/fiber';

export type ScreenShotHelperProps = object;

export interface ScreenShotHelperHandlers {
  getHTMLCanvas: () => HTMLCanvasElement | undefined;
  takeScreenShot: () => string | undefined;
}

export const ScreenShotHelper = forwardRef<ScreenShotHelperHandlers, ScreenShotHelperProps>(
  (_props: ScreenShotHelperProps, reference) => {
    const gl = useThree((state) => state.gl);

    const takeScreenShot = () => {
      if (gl) {
        // var strMime = "image/jpeg";
        // const imgData = gl.domElement.toDataURL(strMime);

        const imgData = gl.domElement.toDataURL();
        return imgData;
      }
      return undefined;
    };

    const getHTMLCanvas = () => {
      if (gl) {
        return gl.domElement;
      }
      return undefined;
    };

    // const saveScreenShot = (imgData: string, filename: string) => {
    //   var a = document.createElement("a");
    //   a.href = imgData;
    //   a.download = filename;
    //   a.click();
    // };

    useImperativeHandle(reference, () => ({ getHTMLCanvas, takeScreenShot }));

    return <></>;
  }
);
